import React, {useEffect} from 'react';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import {useDataProviderState} from '../../providers/DataProvider';
import {formSteps} from '../../constants/form';
import {TrackGoogleAnalyticsEvent} from "../../google-analytics/gaTracker.js";
import useScrollTop from "../../hooks/useScrollTop.js";

export default function ErrorStep() {

    const {errorPageMessage, data} = useDataProviderState();

    const {nombre} = data[formSteps.ID_PHONE];

    useScrollTop();

    TrackGoogleAnalyticsEvent("ErrorStep");

    return (
        <Container component="section" maxWidth="sm">
            <Alert severity="error">
                <AlertTitle>{nombre ? `Estimado ${nombre}` : 'Error'}</AlertTitle>
                <div dangerouslySetInnerHTML={{__html: errorPageMessage || 'Ha ocurrido un error.'}}/>
            </Alert>
        </Container>
    )
}
